import apiClient from './apiClient';
import type {
    TestConfiguration,
    CreateTestConfigurationDto,
    UpdateTestConfigurationDto,
} from '../types/types';

const testConfigsService = {
    getAll: async (): Promise<TestConfiguration[]> => {
        const res = await apiClient.get<TestConfiguration[]>('/test-configurations');
        return res.data;
    },

    getById: async (id: number): Promise<TestConfiguration> => {
        const res = await apiClient.get<TestConfiguration>(`/test-configurations/${id}`);
        return res.data;
    },

    create: async (dto: CreateTestConfigurationDto): Promise<TestConfiguration> => {
        const res = await apiClient.post<TestConfiguration>('/test-configurations', dto);
        return res.data;
    },

    update: async (id: number, dto: UpdateTestConfigurationDto): Promise<TestConfiguration> => {
        const res = await apiClient.patch<TestConfiguration>(`/test-configurations/${id}`, dto);
        return res.data;
    },

    remove: async (id: number): Promise<{ message: string }> => {
        const res = await apiClient.delete<{ message: string }>(`/test-configurations/${id}`);
        return res.data;
    },

    uploadScript: async (id: number, file: File): Promise<TestConfiguration> => {
        const formData = new FormData();
        formData.append('file', file);
        const res = await apiClient.post<TestConfiguration>(`/test-configurations/${id}/script`, formData);
        return res.data;
    },

    deleteScript: async (id: number): Promise<TestConfiguration> => {
        const res = await apiClient.delete<TestConfiguration>(`/test-configurations/${id}/script`);
        return res.data;
    },

    migrateCategories: async (): Promise<{
        updated: number;
        createdCategories: number;
        skipped: number;
    }> => {
        const res = await apiClient.post<{
            updated: number;
            createdCategories: number;
            skipped: number;
        }>('/test-configurations/migrate-categories');
        return res.data;
    },

    migrateIcons: async (): Promise<{
        imported: number;
        linkedConfigs: number;
        linkedCategories: number;
        unmatched: string[];
        iconsPath: string;
        availableFiles: string[];
    }> => {
        const res = await apiClient.post<{
            imported: number;
            linkedConfigs: number;
            linkedCategories: number;
            unmatched: string[];
            iconsPath: string;
            availableFiles: string[];
        }>('/test-configurations/migrate-icons');
        return res.data;
    },

    migrateEntitlements: async (): Promise<{
        createdEntitlements: number;
        linkedConfigs: number;
        linkedCategories: number;
        unmatched: string[];
    }> => {
        const res = await apiClient.post<{
            createdEntitlements: number;
            linkedConfigs: number;
            linkedCategories: number;
            unmatched: string[];
        }>('/test-configurations/migrate-entitlements');
        return res.data;
    },

    migrateMediaFiles: async (): Promise<{
        migratedRows: number;
        linkedPostures: number;
        linkedConfigs: number;
        linkedCategories: number;
    }> => {
        const res = await apiClient.post<{
            migratedRows: number;
            linkedPostures: number;
            linkedConfigs: number;
            linkedCategories: number;
        }>('/test-configurations/migrate-media-files');
        return res.data;
    },
};

export default testConfigsService;
